module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/icn-inquiry-6411cf41083eeaf513608cf419299921.svg";